<template>
<div class="chapter">
<div class="inner_page">
<div class="blockquote">
<p class="noindent"><a id="pii">It is of no use to criticize humanity. Like all creations, it survives its critics. The only interesting thing is to try to understand it or, at least, appreciate. Perhaps Coney Island is the most human thing that God ever made, or permitted the Devil to make.</a></p><a id="pii">
<p class="right">—Richard LeGallienne,</p>
<p class="right2">1905</p>
</a></div><a id="pii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm3.vue?540c891d